import { render, staticRenderFns } from "./custom-item.vue?vue&type=template&id=15fc113e&scoped=true&"
import script from "./custom-item.vue?vue&type=script&lang=js&"
export * from "./custom-item.vue?vue&type=script&lang=js&"
import style0 from "./custom-item.vue?vue&type=style&index=0&id=15fc113e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc113e",
  null
  
)

export default component.exports